import { Injectable } from '@angular/core';
import { iBisEditService, iBisFileService, iBisLanguageService } from '@dohu/ibis-common';
import CustomStore from 'devextreme/data/custom_store';

@Injectable({
  providedIn: 'root'
})
export class ModalFileService extends iBisEditService {
  static readonly COMMERCIAL_PREFIX = 'COMMERCIAL_';

  files!: CustomStore;

  constructor(lg: iBisLanguageService, private file: iBisFileService) {
    super(lg);
    this.title = this.L('FILES');
  }
  createDefault() {
    return {};
  }
  getById(id: string, serverUrl?: string | undefined): Promise<any> {
    throw new Error('Method not implemented.');
  }
  onRemove(id: string): Promise<void> {
    throw new Error('Method not implemented.');
  }
  onSaveEv(serverUrl?: string | undefined): Promise<any> {
    throw new Error('Method not implemented.');
  }
  reset(): void {
    throw new Error('Method not implemented.');
  }

  override showPopup(data: any, byId?: boolean, serverUrl?: string): Promise<any> {
    if (data && data.hideCommercial) {
      this.files = this.commercialFreeStore(data.id);
    }
    return super.showPopup(data, byId, serverUrl);
  }

  override popupInit(event: any): void {
    super.popupInit(event);
    event.component.beginUpdate();
    event.component.option('toolbarItems', []);
    event.component.endUpdate();
  }

  private commercialFreeStore(entityId: string): CustomStore {
    const store: any = this.file.getFileInfo(entityId);
    return new CustomStore({
      key: 'fi_id',
      load: (options: any) => store.load(options).then((resp: any) => {
        const items = Array.isArray(resp) ? resp : resp.data;
        const files = items.filter((f: any) =>
          (f.fi_name || '').toUpperCase().indexOf(ModalFileService.COMMERCIAL_PREFIX) == -1);
        return Array.isArray(resp) ? files : { ...resp, data: files, totalCount: files.length };
      })
    });
  }
}
